import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} data - API response on success/error/loading
 * @param {String} type - type for sucess/error/loading
 */

export const onAnnouncementSuccess = (
  payload = {},
  type = types.SUCCESS_ANNOUNCEMENT
) => {
  return {
    type,
    payload
  };
};

export const isAnnouncementLoading = (
  payload = {},
  type = types.LOADING_ANNOUNCEMENT
) => {
  return {
    type,
    payload
  };
};
